import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "error-msg ep-save" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "ep-save-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, "Save as v" + _toDisplayString(_ctx.saveVersion), 1),
      _cache[12] || (_cache[12] = _createElementVNode("label", {
        class: "ep-lbl",
        for: "ep-status"
      }, "Status", -1)),
      _withDirectives(_createElementVNode("select", {
        id: "ep-status",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.statusModel) = $event))
      }, [...(_cache[7] || (_cache[7] = [
        _createElementVNode("option", { value: "Draft" }, "Draft", -1),
        _createElementVNode("option", { value: "Inactive" }, "Inactive", -1),
        _createElementVNode("option", { value: "Needs Approval" }, "Needs Approval", -1),
        _createElementVNode("option", { value: "" }, "Published/Approved", -1)
      ]))], 512), [
        [_vModelSelect, _ctx.statusModel]
      ]),
      (_ctx.version && !_ctx.status)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "ep-lbl" }, "Did this change how the work is done?", -1)),
            _createElementVNode("label", {
              class: _normalizeClass(['ep-opt', { on: !_ctx.minorChange }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minorChange) = $event)),
                type: "radio",
                value: false
              }, null, 512), [
                [_vModelRadio, _ctx.minorChange]
              ]),
              _createElementVNode("span", null, [
                _cache[9] || (_cache[9] = _createElementVNode("b", null, "Yes, people need to sign again", -1)),
                _createElementVNode("small", null, [
                  _createTextVNode("All " + _toDisplayString(_ctx.requiredCount) + " assigned " + _toDisplayString(_ctx.requiredCount == 1 ? 'person is' : 'people are') + " asked to sign v" + _toDisplayString(_ctx.version + 1), 1),
                  (_ctx.signedCount)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(", including the " + _toDisplayString(_ctx.signedCount) + " who already signed v" + _toDisplayString(_ctx.version), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _cache[8] || (_cache[8] = _createTextVNode(".", -1))
                ])
              ])
            ], 2),
            _createElementVNode("label", {
              class: _normalizeClass(['ep-opt', { on: _ctx.minorChange }])
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.minorChange) = $event)),
                type: "radio",
                value: true
              }, null, 512), [
                [_vModelRadio, _ctx.minorChange]
              ]),
              _createElementVNode("span", null, [
                _cache[10] || (_cache[10] = _createElementVNode("b", null, "No, it's a small fix", -1)),
                _createElementVNode("small", null, "Typos, wording, or formatting. Stays v" + _toDisplayString(_ctx.version) + ", and anyone who signed it stays signed.", 1)
              ])
            ], 2)
          ], 64))
        : _createCommentVNode("", true),
      _cache[13] || (_cache[13] = _createElementVNode("label", {
        class: "ep-lbl",
        for: "ep-note"
      }, [
        _createTextVNode("What changed "),
        _createElementVNode("span", null, "(optional, shows in History)")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        id: "ep-note",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.changeNote) = $event)),
        type: "text",
        maxlength: "500",
        placeholder: _ctx.notePlaceholder,
        onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.save()), ["prevent"]), ["enter"]))
      }, null, 40, _hoisted_3), [
        [_vModelText, _ctx.changeNote]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('cancel')))
        }, "Keep editing"),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.busy ? 'btn disable-button' : 'btn'),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save()))
        }, "Save v" + _toDisplayString(_ctx.saveVersion), 3)
      ])
    ])
  ]))
}